
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveSupplierListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"customer_is_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_nickname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_org_num"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_price_class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_invoice_rule"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_term"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_invoice_by"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_is_risky"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_addresses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_nickname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"line_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"line_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"post_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address_id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":498}};
    doc.loc.source = {"body":"# @format\n\nquery GetActiveSupplierListQuery($company_id: String!) {\n\tcustomers(\n\t\twhere: {\n\t\t\t_and: {\n\t\t\t\tcompany_id: { _eq: $company_id }\n\t\t\t\tcustomer_is_active: { _eq: true }\n\t\t\t}\n\t\t}\n\t) {\n\t\tcustomer_id\n\t\tcustomer_title\n\t\tcustomer_nickname\n\t\tcustomer_org_num\n\t\tcustomer_price_class\n\t\tcustomer_invoice_rule\n\t\tcustomer_term\n\t\tsend_invoice_by\n\t\tcustomer_is_risky\n\t\tcustomer_email\n\t\t_addresses {\n\t\t\taddress_nickname\n\t\t\tline_1\n\t\t\tline_2\n\t\t\tpost_code\n\t\t\tcity\n\t\t\tstate\n\t\t\tcountry\n\t\t\taddress_id\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetActiveSupplierListQuery"] = oneQuery(doc, "GetActiveSupplierListQuery");
        
